import React, { useContext } from 'react'
import { CategoryContext } from '../../context/CategoryContext'
import moment from 'moment';
import { Link } from 'react-router-dom';
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin5Fill } from "react-icons/ri";
import './showcategory.css'


const ShowCategory = () => {

    const {category, deleteCategory} = useContext(CategoryContext)

  return (
    <div className="columns is-justify-content-center">
        <div className="column is-two-thirds">
            <table className='table is-fullwidth has-background-black'>
                <thead>
                    <tr>
                        <th> No </th>
                        <th> Name </th>
                        <th> Creator </th>
                        <th> Publish time </th>
                        <th> Edit </th>
                        <th> Delete </th>
                    </tr>
                </thead>

                <tbody>
                    {
                        category?.map((cat, index) => (
                            <tr key={cat._id}>
                                <td> {index+1} </td>
                                <td> {cat.title} </td>
                                <td> {cat?.user?.firstName} </td>
                                <td> {moment(cat.createdAt).format("YYYY-MM-DD")} </td>
                                <td> 
                                    <Link state={cat} to={`/edit-category/${cat._id}`} className='button is-success has-text-black'>
                                        <FaEdit /> <p className='ml-1'> Edit </p>
                                    </Link>
                                </td>
                                <td>  
                                    <button onClick={()=> deleteCategory(cat._id)} className='button is-danger has-text-black'> 
                                        <RiDeleteBin5Fill /> <p className='ml-1'> Delete </p> 
                                    </button>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>

            </table>
        </div>
    </div>
  )
}

export default ShowCategory
